import React from 'react';

import learn from '../images/icon.book.alt.svg';
import contact from '../images/icon.contact.svg';
import find from '../images/icon.search.svg';
import video from '../images/icon.video.svg';
import menu from '../images/icon.menu.black.svg';
import menuWhite from '../images/icon.menu.white.svg';
import phone from '../images/icon.phone.svg';
import mail from '../images/icon.mail.svg';
import prev from '../images/icon.prev.svg';
import next from '../images/icon.next.svg';
import audioOn from '../images/icon.audio.on.svg';
import audioOff from '../images/icon.audio.off.svg';
import arrow from '../images/icon.arrow.svg';
import user from '../images/icon.user.svg';
import phase from '../images/icon.phase.svg';

const icons = {
    learn,
    contact,
    find,
    video,
    menu,
    phone,
    mail,
    menuWhite,
    audioOn,
    audioOff,
    prev,
    next,
    arrow,
    user,
    phase,
};

export default (props) => {
    const { name, ...rest } = props;
    return <img src={icons[name]} alt={name} {...rest}/>;
};


// WEBPACK FOOTER //
// ./src/components/Icon.js